module.exports = __webpack_public_path__ + "static/media/xfMPfDxxYzNjnZkw60xH.7165a82b.png";